import { AtlasContentScoreV2PageLayout } from 'src/components/AtlasV2Components/AtlasV2PageLayouts/AtlasContentScoreV2PageLayout';
import GenericPageContainer from 'src/components/EntityPage/GenericPageContainer';

export default function getAtlasContentV2PageLayout({ metricType }) {
  const contentPageLayout = {
    contentScore: AtlasContentScoreV2PageLayout
  };
  return {
    CustomPageContainer: GenericPageContainer,
    enableComparison: false,
    widgets: [
      {
        name: 'AtlasContentV2PageLayout',
        CustomComponent: contentPageLayout[metricType],
        view: {}
      }
    ],
    containerStyle: {},
    dataConfig: {}
  };
}
